import "core-js/modules/es6.function.name";
import "core-js/modules/es6.object.assign";

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

import sizes from "../foundations/sizes";
import { randomColor, isDark, mode } from "@chakra-ui/theme-tools";

function getSize(size) {
  var themeSize = sizes[size];
  var styles = {
    width: size,
    height: size,
    fontSize: "calc(" + (themeSize != null ? themeSize : size) + " / 2.5)"
  };

  if (size !== "100%") {
    styles.lineHeight = themeSize != null ? themeSize : size;
  }

  return {
    Root: styles,
    ExcessLabel: styles
  };
}

function getRootStyle(props) {
  var name = props.name,
      t = props.theme;
  var bg = name ? randomColor({
    string: name
  }) : "gray.400";
  var isBgDark = isDark(bg)(t);
  var color = name ? isBgDark ? "white" : "gray.800" : "white";
  var borderColor = mode("white", "gray.800")(props);
  return {
    bg: bg,
    color: color,
    borderColor: borderColor
  };
}

var Avatar = {
  defaultProps: {
    size: "md"
  },
  baseStyle: function baseStyle(props) {
    return {
      Root: _extends({
        verticalAlign: "top"
      }, getRootStyle(props)),
      Badge: {
        transform: "translate(25%, 25%)",
        borderRadius: "full",
        border: "0.2em solid",
        borderColor: mode("white", "gray.800")(props)
      },
      ExcessLabel: {
        bg: mode("gray.200", "whiteAlpha.400")(props)
      }
    };
  },
  sizes: {
    "2xs": getSize("4"),
    xs: getSize("6"),
    sm: getSize("8"),
    md: getSize("12"),
    lg: getSize("16"),
    xl: getSize("24"),
    "2xl": getSize("32"),
    full: getSize("100%")
  }
};
export var AvatarSizes = {
  "2xs": "2xs",
  xs: "xs",
  sm: "sm",
  md: "md",
  lg: "lg",
  xl: "xl",
  "2xl": "2xl",
  full: "full"
};
export default Avatar;